const renderRefinementList = (renderOptions, isFirstRender) => {
  const { items, refine, createURL, widgetParams } = renderOptions;

  if (isFirstRender) {
    const ul = document.createElement("ul");
    ul.className = "list-facet__list list-unstyled";

    widgetParams.container.appendChild(ul);
  }

  widgetParams.container.querySelector("ul").innerHTML = items
    .map(
      (item) => `
        <li>
          <a
            href="${createURL(item.value)}"
            data-value="${item.value}"
            class="list-facet__item${
              item.isRefined ? " list-facet__item--selected" : ""
            }"
          >
            ${item.label}
          </a>
        </li>
      `
    )
    .join("");

  [...widgetParams.container.querySelectorAll("a")].forEach((element) => {
    element.addEventListener("click", (e) => {
      e.preventDefault();
      refine(e.currentTarget.dataset.value);
    });
  });
};

export const facet =
  window.instantsearch.connectors.connectRefinementList(renderRefinementList);
